/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootboxCartItem } from './LootboxCartItem';
import {
    LootboxCartItemFromJSON,
    LootboxCartItemFromJSONTyped,
    LootboxCartItemToJSON,
    LootboxCartItemToJSONTyped,
} from './LootboxCartItem';

/**
 * 
 * @export
 * @interface LootboxTransactionHistoryItem
 */
export interface LootboxTransactionHistoryItem {
    /**
     * LootBox purchase ID
     * @type {string}
     * @memberof LootboxTransactionHistoryItem
     */
    id?: string;
    /**
     * Total amount paid in USD cents
     * @type {number}
     * @memberof LootboxTransactionHistoryItem
     */
    amount?: number;
    /**
     * Formatted USD amount (e.g., "$12.50")
     * @type {string}
     * @memberof LootboxTransactionHistoryItem
     */
    amountFormatted?: string;
    /**
     * Purchase status (MINTED for completed)
     * @type {string}
     * @memberof LootboxTransactionHistoryItem
     */
    status?: string;
    /**
     * Human-readable description
     * @type {string}
     * @memberof LootboxTransactionHistoryItem
     */
    description?: string;
    /**
     * Items purchased in this order
     * @type {Array<LootboxCartItem>}
     * @memberof LootboxTransactionHistoryItem
     */
    cartItems?: Array<LootboxCartItem>;
    /**
     * Purchase timestamp
     * @type {Date}
     * @memberof LootboxTransactionHistoryItem
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the LootboxTransactionHistoryItem interface.
 */
export function instanceOfLootboxTransactionHistoryItem(value: object): value is LootboxTransactionHistoryItem {
    return true;
}

export function LootboxTransactionHistoryItemFromJSON(json: any): LootboxTransactionHistoryItem {
    return LootboxTransactionHistoryItemFromJSONTyped(json, false);
}

export function LootboxTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'amountFormatted': json['amountFormatted'] == null ? undefined : json['amountFormatted'],
        'status': json['status'] == null ? undefined : json['status'],
        'description': json['description'] == null ? undefined : json['description'],
        'cartItems': json['cartItems'] == null ? undefined : ((json['cartItems'] as Array<any>).map(LootboxCartItemFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function LootboxTransactionHistoryItemToJSON(json: any): LootboxTransactionHistoryItem {
    return LootboxTransactionHistoryItemToJSONTyped(json, false);
}

export function LootboxTransactionHistoryItemToJSONTyped(value?: LootboxTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'amountFormatted': value['amountFormatted'],
        'status': value['status'],
        'description': value['description'],
        'cartItems': value['cartItems'] == null ? undefined : ((value['cartItems'] as Array<any>).map(LootboxCartItemToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

